import * as Jwp from "./jwplayer/jwplayerRender"

export const initialize = () => {
    //todo: como se cargan asincronicamente tengo que esperar que las variables esten llenas. Pero una vez que este importado en el proyecto se elimina el interval.
    let interval = setInterval(function() {
        if (window.JW != undefined && window.JW.ads != undefined && window.JW.ads != null) {
            clearInterval(interval);
            const videos = Array.from(document.getElementsByClassName("videoAside"));
            for (let video of videos) {
                const
                    videoId = video.getAttribute("data-video_id"),
                    multimediofileId = video.getAttribute("data-multimediofile_id"),
                    multimediofileJWKey = video.getAttribute("data-jwkey"),
                    multimedioJWKey = video.getAttribute("data-multimediojwkey"),
                    videoDestacado = video.getAttribute("data-destacado"),
                    showAds = video.getAttribute("data-showads"),
                    arrayTags = video.getAttribute("data-arraytags"),
                    videoTagHome = video.getAttribute("data-videotag_home"),
                    contenedor = video.getAttribute("data-contenedor"),
                    titulo = video.getAttribute("data-titulo"),
                    autoPlay = video.getAttribute("data-autoplay") === 1;

                if (videoId && multimediofileId) {
                    Jwp.render(video,
                        videoId,
                        multimediofileId,
                        multimedioJWKey,
                        multimediofileJWKey,
                        !!videoDestacado,
                        showAds,
                        autoPlay,
                        arrayTags,
                        videoTagHome,
                        contenedor,
                        titulo);
                }
            }
        }
    }, 2000);
};


// WEBPACK FOOTER //
// ./Statics/scripts/common/video.js